import TiremetrixWarningsHtml from './tiremetrix.warnings.html';

export function TiremetrixWarnings () {
  return {
    restrict: 'E',
    templateUrl: TiremetrixWarningsHtml,
    scope: {
      data: '=',
      id: '@'
    },
    link: function (scope, element, attrs) {
      scope.type = 'warning';

      scope.dismissedOn = localStorage[scope.id + '_notifications_dismissed_on'];

      scope.dismissed = function () {
        if (!scope.dismissedOn) {
          return false;
        }

        var createdOn   = moment(scope.data[0].created_on);
        var dismissedOn = moment(scope.dismissedOn);

        return dismissedOn.isAfter(createdOn);
      };

      scope.dismiss = function () {
        scope.dismissedOn = moment().toISOString();
        localStorage[scope.id + '_notifications_dismissed_on'] = scope.dismissedOn;
      }
    }
  };
}